import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import SearchGoodsList from "./components/list";

const SearchGoods = () => {

  /** redux store useDispatch & useSelector ------------------------------ **/
  const Location = useLocation();

  return (
    <>
      <Routes>
        <Route path={`/`} element={<Navigate replace="/" to={`${Location.pathname}/list`} />}></Route>
        <Route path={"list"} element={<SearchGoodsList />}></Route>
      </Routes>
    </>
  );

};

export default SearchGoods;
